import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  maxWidthStyle: {
    minWidth: "100%",
    width: "100%"
  },
  '& .MuiStepConnector-completed': {
    '& .MuiStepConnector-line': {
      borderColor: theme.palette.primary.main,
      borderTopWidth: 3,
      borderRadius: 1,
    }
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: "10px",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  justifyEnd: {
    justifyContent: 'flex-end',
  },
  justifyText: {
    textAlign: 'justify',
  },
  justifyItems: {
    alignItems: 'center',
  },
  completedConnector: {
    '& .MuiStepConnector-line': {
      borderColor: theme.palette.primary.main,
      borderTopWidth: 3,
      borderRadius: 1,
    }
  },
  formControlAutoComplete: {
    minWidth: "100%",
    margin: "10px"
  },
}), {index: 1});
